import ApiCaller from "./apiCaller";

export const getStoreStatistic = () => ApiCaller.get("store/statistic");

export const getSiteStatistic = (
  loadStatusBarOnProgressOnly: boolean = false
) => {
  let uri = "site/statistic";
  if (loadStatusBarOnProgressOnly) {
    uri = `${uri}?is_show_on_progress_bar=1`;
  }
  return ApiCaller.get(uri);
};

export const getCity = () => {
  return ApiCaller.get("city/");
};

export const getSiteListing = (params: string) => {
  return ApiCaller.get(`site/list?${params}`);
};

export const getStatusListing = (brandId: string) => {
  return ApiCaller.get(
    `status/?q=(filters:!((col:content_type,opr:eq,value:site),(col:brand,opr:rel_o_m,value:${brandId})))`
  );
};

export const getUserListing = () => {
  return ApiCaller.get("user/current_brand");
};

export const getSiteContract = (siteId: string) => {
  return ApiCaller.get(`contract?site_id=${siteId}&limit=20`);
};

export const getSiteDetail = (siteId: string, noAttachment: boolean) => {
  let uri = `site/${siteId}?include_status_history=1`;
  if (noAttachment) {
    uri = `${uri}&no_attachment=1`;
  }
  return ApiCaller.get(uri);
};

export const getContract = (params: any = {}) => {
  const {
    page,
    limit,
    is_can_edit,
    contract_code,
    site_address,
    internal_code,
    contract_valid_from,
    contract_valid_to,
    used_for_rental_fee_calculation,
  } = params;
  let uri = `contract?page=${page}&limit=${limit}`;
  if (is_can_edit != null) {
    uri += `&is_can_edit=${is_can_edit}`;
  }
  if (used_for_rental_fee_calculation !== null) {
    uri += `&used_for_rental_fee_calculation=${
      used_for_rental_fee_calculation ? 1 : 0
    }`;
  }
  if (contract_code) {
    uri += `&contract_code=${contract_code}`;
  }
  if (site_address) {
    uri += `&site_address=${site_address}`;
  }
  if (internal_code) {
    uri += `&internal_code=${internal_code}`;
  }
  if (contract_valid_from) {
    uri += `&contract_valid_from=${contract_valid_from}`;
  }
  if (contract_valid_to) {
    uri += `&contract_valid_to=${contract_valid_to}`;
  }
  return ApiCaller.get(uri);
};

export const changeSiteStatus = (
  siteId: string,
  suffix: string,
  reason?: string
) => {
  return ApiCaller.put(`site/${siteId}/${suffix}`, { reason_rollback: reason });
};

export const hideSite = (siteId: string) => {
  return ApiCaller.put(`site/${siteId}/hide`);
};

export const upgradeSiteToStore = (siteId: string) => {
  return ApiCaller.post(`site/${siteId}/upgrade_to_store`);
};

export const getEstimation = (siteId: string) => {
  return ApiCaller.get(`site_comment/${siteId}/performance_estimation`);
};

export const getExistingAiEstimation = (siteId: string) => {
  return ApiCaller.get(`siteaifinancialprojectionmodelapi/site_ml/${siteId}`);
};

export const getAISitePerformancePrediction = (siteId: string) => {
  return ApiCaller.post(`siteaifinancialprojectionmodelapi/site_ml/${siteId}`);
};

export const getSiteStatusMapping = () => {
  return ApiCaller.get(`site/status`);
};

export const getStoreStatusMapping = () => {
  return ApiCaller.get(`store/status`);
};

export const changeStoreStatus = (
  storeId: string,
  suffix: string,
  reason?: string
) => {
  return ApiCaller.put(`store/${storeId}/${suffix}`, {
    reason_rollback: reason,
  });
};

export const getFinancialPerformance = (storeId: string) =>
  ApiCaller.get(`store/${storeId}/financial/summary`);

export const terminateContract = (id: number, data: any) =>
  ApiCaller.post(`contract/${id}/terminate`, data);
